import React from "react";

export interface LongTextProps {
  className?: string;
  children: React.ReactNode;
  maxLength?: number;
}

export function LongText({
  className,
  children,
  maxLength = 100,
}: LongTextProps) {
  const text = typeof children === "string" ? children : String(children);
  const truncatedText =
    text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

  return (
    <span className={className} title={text}>
      {truncatedText}
    </span>
  );
}
